import { OverlayContainer, PopupContainer } from "@kalyzee/kast-web-sdk/web-components";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./app/App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import setupStore from "./store/store";
import { Debug } from "./helpers/debug";
import { StyleProvider } from "@kalyzee/escaet-ui";

import "@kalyzee/kast-web-sdk/web-components.css";
import "@kalyzee/escaet-ui/style.css";
import "react-datepicker/dist/react-datepicker.css";
import { init } from "@kalyzee/kast-web-sdk";

init({ lang: "fr" });

Debug.init(true);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const store = setupStore();

// FOR DEBUG
// EN -> https://en.reactjs.org/docs/strict-mode.html
// FR -> https://fr.reactjs.org/docs/strict-mode.html
const ENABLE_STRICT_MODE = false;
const renderApp = () => (
  <Provider store={store}>
    <StyleProvider>
      <PopupContainer />
      <OverlayContainer />
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ToastContainer position="top-right" pauseOnFocusLoss={false} draggable={false} pauseOnHover={false} className="toast-container" />
    </StyleProvider>
  </Provider>
);

root.render(<Suspense fallback>{ENABLE_STRICT_MODE ? <React.StrictMode>{renderApp()}</React.StrictMode> : renderApp()}</Suspense>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
